// noinspection JSUnresolvedReference

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'trixText' ]

  connect() {
    this.trixTextTargets.forEach(target => {
      const trixFileTools = target.previousSibling.querySelector('.trix-button-group--file-tools');

      if (trixFileTools) {
        trixFileTools.style.display = 'none';
      }
    });
  }

  disableAttachment(event) {
    event.preventDefault();
  }
}